import React from "react";
import { Link } from "react-router-dom";
import green_switch_ea from "../assets/images/green_switch_ea.png"
import purpledot from '../assets/images/purple_squre_dots.b6e7dbcc.svg'
import yellowdot from '../assets/images/yellow_squre_dots.a8deef14.svg'
import eac1 from '../assets/images/eac1.svg'
import eac2 from '../assets/images/eac2.svg'
import eac3 from '../assets/images/eac3.svg'
import eac4 from '../assets/images/eac4.svg'
import eac5 from '../assets/images/eac5.svg'
import eac6 from '../assets/images/eac6.svg'
import eaeg from '../assets/images/eaeg.png'

function EaStudyMaterials() {
  return (
    <>
      <div className="overflow-hidden bg-placement-hero bg-cover w-full">
        <div className="max-w-7xl m-auto relative isolate px-6 pt-14 lg:px-8 h-[55%] md:h-[50%] lg:h-[80%] lg:mb-0 lg:pt-2 xl:pt-2">
          <img src={green_switch_ea} alt="" className="absolute object-contain inset-0 z-10 scale-75 lg:scale-[70%] -mt-14 ml-16 md:ml-32 md:-mt-32 lg:ml-52 lg:-mt-40 xl:-mt-[16rem] mt-[0] xl:scale-[65%] xl:ml-96 2xl:ml-[22rem]" />
          <div className="mx-auto py-10 md:py-24 lg:py-48 relative z-10 text-white">
            <div className="mx-auto lg:max-w-5xl">
              <h1 className="text-left lg:text-5xl md:text-4xl text-3xl font-bold text-gray-700 lg:w-[38%] w-[90%] mb-2 lg:leading-[56px]"><span className="block">Enrolled Agent</span><span className="block">Course Materials</span></h1>

              <div className="scale-[60%] md:scale-75 lg:scale-100 mt-5 md:mt-4 lg:mt-10 flex flex-row gap-10 -ml-24 md:-ml-28 lg:ml-0 items-start justify-start gap-x-2 lg:gap-x-6">
                  <div className="box box_btn transform transition-transform duration-300 hover:scale-110" tabindex="0">
                      <Link to="https://www.kcglobed.com/contactus#EnquireForm"
                          className="relative lg:top-[33px] bg-[#fbb03b] transition duration-300 rounded-3xl bg-primary px-6 py-4 text-sm font-semibold text-gray-700 shadow-sm hover:bg-primary hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary pb-4 cursor-pointer"
                      >
                          Enquiry Now
                      </Link>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative bg-[#f2f2f2] p-4 md:p-8 lg:p-10 py-[91px] lg:pt-[71px]">
        <img src={purpledot} alt="purpledot" className='absolute w-[91px] left-[21px] top-[2rem]' />
        <div className="flex flex-col items-center">
          <div tabindex="0" style={{ transform: 'none' }}>
            <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-0 p-8 items-center xs:max-w-xl lg:max-w-6xl group h-full">
              <img src={eaeg} alt="" className="h-50 w-30 mb-6 lg:pr-10" />
              <div className="flex flex-col lg:mr-6">
                <h2 className="font-semibold text-left text-2xl md:text-4xl text-gray-700 mb-4">
                  <span className='uppercase text-xl'>Enrolled Agent Course</span>
                  <span className="block mt-1" style={{ color: 'rgb(134, 53, 122)' }}>
                    Materials and Exam Prep in India
                  </span>
                </h2>
                <p className="text-[15px] text-base md:text-medium text-left text-dark_text">
                  If you&#39;re looking to become an Enrolled Agent (EA) in India,
                  having the right study materials is crucial for your success.
                  Here’s a comprehensive guide to some of the best resources
                  available in our AI Powered LMS for Enrolled Agent Course.
                </p>
              </div>
            </div>
          </div>
        </div>
        <img src={yellowdot} alt="yellowdot" className='w-[51px] absolute bottom-[2rem] right-[21px]' />
      </div>

      <div className="relative lg:py-10 lg:px-10 py-0 px-6">
        <div className="flex flex-col items-center">
          <div className="relative overflow-hidden">
            <div className="max-w-[85rem] mx-auto px-4 sm:px-6 lg:px-8 py-10">
              <div className="max-w-3xl text-center mx-auto">
                <h2 className="block text-2xl md:text-4xl font-bold text-gray-800">
                  <span className="uppercase text-xl">Key Features of</span>
                </h2>
                <h2
                  className="mt-2 block text-2xl md:text-4xl font-bold "
                  style={{ color: "rgb(134, 53, 122)" }}
                >
                  Enrolled Agent Course Materials
                </h2>
              </div>
            </div>
          </div>
          <div className="lg:max-w-3xl px-4 py-6 justify-center items-center">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 justify-center items-center">
              <div tabindex="0" style={{ transform: "none" }}>
                <div
                  className="group flex flex-col lg:h-[16rem] rounded-xl transition shadow-[inset_2px_3px_6px_#46464620] transform transition-transform duration-300 hover:scale-110"
                  href="#"
                  style={{ backgroundColor: "rgb(255, 247, 235)" }}
                >
                  <div
                    className="relative overflow-hidden"
                    style={{ width: "fit-content" }}
                  >
                    <div style={{ opacity: "1", transform: "none" }}>
                      <div className="p-4 flex-grow">
                        <div className="flex items-start">
                          <div className="grow flex flex-col items-start">
                            <div className="w-full flex flex-row items-center justify-between">
                              <h3 className="text-[3rem] font-semibold text-primary_text">
                                1
                              </h3>
                              <img className="w-16 h-16" src={eac1} alt="" />
                            </div>
                            <h3 className="font-semibold text-[#6C38CC] min-w-[186px]">
                              Comprehensive Topic Coverage
                            </h3>
                          </div>
                        </div>
                        <p className="lg:text-xs font-light mr-5">
                          Courses cover all topics for the EA exam based on the
                          blueprints issued by IRS, including taxpayer data,
                          income and assets, deductions and credits, and
                          specialized returns etc.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div tabindex="0" style={{ transform: "none" }}>
                <div
                  className="group flex flex-col lg:h-[16rem] rounded-xl transition shadow-[inset_2px_3px_6px_#46464620] transform transition-transform duration-300 hover:scale-110"
                  href="#"
                  style={{ backgroundColor: "rgb(235, 243, 248)" }}
                >
                  <div
                    className="relative overflow-hidden"
                    style={{ width: "fit-content" }}
                  >
                    <div style={{ opacity: "1", transform: "none" }}>
                      <div className="p-4 flex-grow">
                        <div className="flex items-start">
                          <div className="grow flex flex-col items-start">
                            <div className="w-full flex flex-row items-center justify-between">
                              <h3 className="text-[3rem] font-semibold text-primary_text">
                                2
                              </h3>
                              <img className="w-16 h-16" src={eac2} alt="" />
                            </div>
                            <h3 className="font-semibold text-[#6C38CC] min-w-[186px]">
                              Diverse Study Materials
                            </h3>
                          </div>
                        </div>
                        <p className="lg:text-xs font-light mr-5">
                          Materials include a mix of video lactures, textbooks,
                          practice questions, and live classes to ensure a
                          thorough understanding of the EA exam syllabus.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div tabindex="0" style={{ transform: "none" }}>
                <div
                  className="group flex flex-col lg:h-[16rem] rounded-xl transition shadow-[inset_2px_3px_6px_#46464620] transform transition-transform duration-300 hover:scale-110"
                  href="#"
                  style={{ backgroundColor: "rgb(245, 249, 243)" }}
                >
                  <div
                    className="relative overflow-hidden"
                    style={{ width: "fit-content" }}
                  >
                    <div style={{ opacity: "1", transform: "none" }}>
                      <div className="p-4 flex-grow">
                        <div className="flex items-start">
                          <div className="grow flex flex-col items-start">
                            <div className="w-full flex flex-row items-center justify-between">
                              <h3 className="text-[3rem] font-semibold text-primary_text">
                                3
                              </h3>
                              <img className="w-16 h-16" src={eac3} alt="" />
                            </div>
                            <h3 className="font-semibold text-[#6C38CC] min-w-[186px]">
                              Experiential Learning
                            </h3>
                          </div>
                        </div>
                        <p className="lg:text-xs font-light mr-5">
                          Our EA study program include comprehensive
                          experiential learning with real world case studies,
                          tax preparation work and use of tools to file tax
                          returns etc. that equipped candidates market ready.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div tabindex="0" style={{ transform: "none" }}>
                <div
                  className="group flex flex-col lg:h-[16rem] rounded-xl transition shadow-[inset_2px_3px_6px_#46464620] transform transition-transform duration-300 hover:scale-110"
                  href="#"
                  style={{ backgroundColor: "rgb(235, 243, 248)" }}
                >
                  <div
                    className="relative overflow-hidden"
                    style={{ width: "fit-content" }}
                  >
                    <div style={{ opacity: "1", transform: "none" }}>
                      <div className="p-4 flex-grow">
                        <div className="flex items-start">
                          <div className="grow flex flex-col items-start">
                            <div className="w-full flex flex-row items-center justify-between">
                              <h3 className="text-[3rem] font-semibold text-primary_text">
                                4
                              </h3>
                              <img className="w-16 h-16" src={eac4} alt="" />
                            </div>
                            <h3 className="font-semibold text-[#6C38CC] min-w-[186px]">
                              Regular Updates
                            </h3>
                          </div>
                        </div>
                        <p className="lg:text-xs font-light mr-5">
                          Study materials are frequently updated to reflect the
                          latest tax laws and exam formats, ensuring current and
                          relevant information.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div tabindex="0" style={{ transform: "none" }}>
                <div
                  className="group flex flex-col lg:h-[16rem] rounded-xl transition shadow-[inset_2px_3px_6px_#46464620] transform transition-transform duration-300 hover:scale-110"
                  href="#"
                  style={{ backgroundColor: "rgb(255, 247, 235)" }}
                >
                  <div
                    className="relative overflow-hidden"
                    style={{ width: "fit-content" }}
                  >
                    <div style={{ opacity: "1", transform: "none" }}>
                      <div className="p-4 flex-grow">
                        <div className="flex items-start">
                          <div className="grow flex flex-col items-start">
                            <div className="w-full flex flex-row items-center justify-between">
                              <h3 className="text-[3rem] font-semibold text-primary_text">
                                5
                              </h3>
                              <img className="w-16 h-16" src={eac5} alt="" />
                            </div>
                            <h3 className="font-semibold text-[#6C38CC] min-w-[186px]">
                              Adaptive Learning Platforms
                            </h3>
                          </div>
                        </div>
                        <p className="lg:text-xs font-light mr-5">
                          Our AI Powered LMS offer complete adaptive learning
                          technology that help focus on areas needing
                          improvement, including thousands of multiple-choice
                          questions and detailed explanations.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div tabindex="0" style={{ transform: "none" }}>
                <div
                  className="group flex flex-col lg:h-[16rem] rounded-xl transition shadow-[inset_2px_3px_6px_#46464620] transform transition-transform duration-300 hover:scale-110"
                  href="#"
                  style={{ backgroundColor: "rgb(245, 249, 243)" }}
                >
                  <div
                    className="relative overflow-hidden"
                    style={{ width: "fit-content" }}
                  >
                    <div style={{ opacity: "1", transform: "none" }}>
                      <div className="p-4 flex-grow">
                        <div className="flex items-start">
                          <div className="grow flex flex-col items-start">
                            <div className="w-full flex flex-row items-center justify-between">
                              <h3 className="text-[3rem] font-semibold text-primary_text">
                                6
                              </h3>
                              <img className="w-16 h-16" src={eac6} alt="" />
                            </div>
                            <h3 className="font-semibold text-[#6C38CC] min-w-[186px]">
                              Blended Learning Resources
                            </h3>
                          </div>
                        </div>
                        <p className="lg:text-xs font-light mr-5">
                          A combination of online and offline resources, such as
                          study guides, video lectures, live classes and
                          practice tests, covering all parts of the EA exam.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-[#f2f2f2] relative lg:py-10 lg:px-10 py-0 pt-[71px] pb-[121px]">
        <img src={purpledot} alt="purpledot" className='absolute w-[91px] left-[21px] top-[2rem]' />
        <div className="flex flex-col items-center">
          <div className="relative overflow-hidden">
            <div className="max-w-[85rem] mx-auto px-4 sm:px-6 lg:px-8 py-10">
              <div className="max-w-3xl text-center mx-auto">
                <h2 className="block text-2xl md:text-4xl font-bold text-gray-800">
                  <span className="uppercase text-xl">Best Books for</span>
                </h2>
                <h2
                  className="mt-2 block text-2xl md:text-4xl font-bold "
                  style={{ color: "rgb(134, 53, 122)" }}
                >
                  Enrolled Agent Exam
                </h2>
              </div>
            </div>
          </div>
          <div className="lg:max-w-5xl px-4 py-6 justify-center items-center">
            <div className="">
              <div tabindex="0" style={{ transform: "none" }}>
                <div
                  className="group flex flex-col rounded-xl transition bg-white transform transition-transform duration-300 hover:scale-110"
                  href="#"
                >
                  <div
                    className="relative overflow-hidden"
                    style={{ width: "fit-content" }}
                  >
                    <div style={{ opacity: "1", transform: "none" }}>
                      <div className="p-6 flex-grow">
                        <div className="grow flex flex-col items-start">
                          <h3 className=" text-2xl font-semibold text-[#6C38CC] min-w-[186px] mb-3">
                            Key Features of Enrolled Agent Exam Prep Books
                          </h3>
                        </div>
                        <ul class="space-y-2 list-disc ml-4 text-[15px] text-base md:text-medium text-left text-dark_text mb-2">
                          <li>100% aligned with the blueprints issued by IRS.</li>
                          <li>Easy to understand language.</li>
                          <li>Practical approach to make learner better understand key concepts which they will be applying while working as US Tax experts.</li>
                          <li>Practice questions for each topic to prepare exam ready.</li>
                          <li>All relevant US Tax forms to make you comfortable while studying with tax filing and representation before IRS.</li>
                        </ul>
                        <div className="flex items-start">
                          <h3 className="text-2xl mt-2 font-semibold text-[#6C38CC] min-w-[186px] mb-3">
                            Preparing for the EA Exam
                          </h3>
                        </div>
                        <ul class="space-y-2 text-[15px] text-base md:text-medium text-left text-dark_text mb-2">
                          <li>A combination of these study materials and choosing the right exam center will significantly enhance your preparation and confidence. Utilize the best resources of KC GlobEd, to ensure a well-rounded understanding and thorough preparation for the EA exam.</li>
                          <li className="text-[#8746ff]">For more information, you can visit us at KC GlobEd. By leveraging these resources, you will be well-equipped to pass the EA exam and advance your career in tax consultation.</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <img src={yellowdot} alt="yellowdot" className='w-[51px] absolute bottom-[2rem] right-[21px]' />
      </div>
    </>
  );
}
export default EaStudyMaterials;
